import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
// import dynamic from 'next/dynamic'

import useOnMouseAndScroll from '@shared/hooks/useOnMouseAndScroll'
import AdsCode from '@shared/components/ads/adsCode'
import useWindowSize from '@shared/hooks/windowSize'
import { getDeviceInfo } from '@shared/libs/menu'
import { staticPages } from '@shared/constants/staticPages'
import { useRouter } from 'next/router'

function Ads({ hidePreview, hideOn = 'none', ...rest }) {
  const router = useRouter()
  const { isMobile } = getDeviceInfo()
  const { isLoaded } = useOnMouseAndScroll()
  const [width] = useWindowSize()
  const { isDesktop, isMobileDevice } = useMemo(() => checkDevice(), [width])
  const isStaticPage = staticPages?.some((path) => router?.asPath.startsWith(path))

  function getHeight() {
    if (rest?.dimensionDesktop && (width > 767 || !isMobile)) {
      // For Desktop
      return rest?.dimensionDesktop[1] || 90
    } else if (rest?.dimensionMobile && (width < 767 || isMobile)) {
      // For mobile
      return rest?.dimensionMobile[1] || 250
    } else if (rest?.dimensionDesktop && !rest?.dimensionMobile && !rest?.mobile && (width < 767 || isMobile)) {
      // For only mobile
      return rest?.dimensionDesktop[1] || 250
    } else return 0
  }

  function checkDevice() {
    return {
      isDesktop: width ? width > 767 : !isMobile,
      isMobileDevice: width ? width < 767 : isMobile
    }
  }

  if (isStaticPage) return null
  if (isLoaded && ((width > 767 && hideOn !== 'desktop') || (width < 767 && hideOn !== 'mobile') || hideOn === 'none')) {
    // Sometime header is not passing properly so using width for perfect condition
    return <AdsCode {...rest} height={hidePreview ? 0 : getHeight() + 10} hidePreview={hidePreview} />
  } else {
    if ((isDesktop && hideOn !== 'desktop') || (isMobileDevice && hideOn !== 'mobile') || hideOn === 'none') {
      return (
        <div
          className={`ads-box w-100 rounded-2 ${rest?.className || ''}`}
          style={{ minHeight: hidePreview ? '0' : `${getHeight() + 10}px` }}
        />
      )
    } else return null
  }
}

Ads.propTypes = {
  id: PropTypes.string,
  // hideOn: PropTypes.string,
  hideOn: PropTypes.oneOf(['desktop', 'mobile', 'none']),
  adIdDesktop: PropTypes.string,
  adIdMobile: PropTypes.string,
  className: PropTypes.string,
  dimensionDesktop: PropTypes.array,
  dimensionMobile: PropTypes.array,
  hidePreview: PropTypes.bool,
  mobile: PropTypes.bool
}
export default Ads
